import { UpdateSensorTagListDataModel, UpdateSensorTagListDataPayload } from '../models';

const updateSensorTagListToPayload = (model: UpdateSensorTagListDataModel): UpdateSensorTagListDataPayload => {
  const { deviceId, gatewayId, sensorId, tags } = model;

  return {
    device_id: deviceId,
    gateway_id: gatewayId,
    sensor_id: sensorId,
    tags,
  };
};

export const updateSensorListTagListToPayload = (models: UpdateSensorTagListDataModel[]): UpdateSensorTagListDataPayload[] => {
  return models.map((item) => updateSensorTagListToPayload(item));
};
